// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SolutionsRouteImport } from './routes/solutions'
import { Route as SecuritySolutionsRouteImport } from './routes/security-solutions'
import { Route as SecurityConsultantInIndiaRouteImport } from './routes/security-consultant-in-india'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as PerimeterSecurityExpertInIndiaRouteImport } from './routes/perimeter-security-expert-in-india'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as MediaRouteImport } from './routes/media'
import { Route as LearningCenterRouteImport } from './routes/learning-center'
import { Route as InsightsRouteImport } from './routes/insights'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as ForArchitectsRouteImport } from './routes/for-architects'
import { Route as ElvConsultantInIndiaRouteImport } from './routes/elv-consultant-in-india'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AvConsultantInIndiaRouteImport } from './routes/av-consultant-in-india'
import { Route as AskArifRouteImport } from './routes/ask-arif'
import { Route as AiEntityMapRouteImport } from './routes/ai-entity-map'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ResourcesIndexRouteImport } from './routes/resources.index'
import { Route as LocationsIndexRouteImport } from './routes/locations.index'
import { Route as ResourcesSlugRouteImport } from './routes/resources.$slug'
import { Route as LocationsSecurityConsultantDelhiNcrRouteImport } from './routes/locations.security-consultant-delhi-ncr'
import { Route as LocationsHomeCinemaConsultantDelhiNcrRouteImport } from './routes/locations.home-cinema-consultant-delhi-ncr'
import { Route as LocationsAuditoriumAvConsultantDelhiNcrRouteImport } from './routes/locations.auditorium-av-consultant-delhi-ncr'
import { Route as LocationsSlugRouteImport } from './routes/locations.$slug'
import { Route as AdminSeoMonitorRouteImport } from './routes/admin.seo-monitor'
import { Route as AdminSecurityMonitorRouteImport } from './routes/admin.security-monitor'
import { Route as AdminPublishCheckRouteImport } from './routes/admin.publish-check'
import { Route as AdminLinkedinCardsRouteImport } from './routes/admin.linkedin-cards'
import { Route as AdminGrowthRouteImport } from './routes/admin.growth'
import { Route as AdminFunnelRouteImport } from './routes/admin.funnel'
import { Route as AdminCtaClicksRouteImport } from './routes/admin.cta-clicks'
import { Route as AdminAbWhatsappRouteImport } from './routes/admin.ab-whatsapp'
import { Route as SolutionsIndexRouteImport } from './routes/solutions.index'
import { Route as SolutionsSlugRouteImport } from './routes/solutions.$slug'
import { Route as InsightsIndexRouteImport } from './routes/insights.index'
import { Route as InsightsPartnersRouteImport } from './routes/insights.partners'
import { Route as InsightsMediaRouteImport } from './routes/insights.media'
import { Route as InsightsLearningCentreRouteImport } from './routes/insights.learning-centre'
import { Route as InsightsArticlesGuidesRouteImport } from './routes/insights.articles-guides'
import { Route as IndustriesIndexRouteImport } from './routes/industries.index'
import { Route as IndustriesSlugRouteImport } from './routes/industries.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AskArifIndexRouteImport } from './routes/ask-arif.index'
import { Route as AskArifSlugRouteImport } from './routes/ask-arif.$slug'
import { Route as AskArifCategoryCategoryRouteImport } from './routes/ask-arif.category.$category'

const SolutionsRoute = SolutionsRouteImport.update({
            id: '/solutions',path: '/solutions',getParentRoute: () => rootRouteImport
          })
const SecuritySolutionsRoute = SecuritySolutionsRouteImport.update({
            id: '/security-solutions',path: '/security-solutions',getParentRoute: () => rootRouteImport
          })
const SecurityConsultantInIndiaRoute = SecurityConsultantInIndiaRouteImport.update({
            id: '/security-consultant-in-india',path: '/security-consultant-in-india',getParentRoute: () => rootRouteImport
          })
const ProjectsRoute = ProjectsRouteImport.update({
            id: '/projects',path: '/projects',getParentRoute: () => rootRouteImport
          })
const PerimeterSecurityExpertInIndiaRoute = PerimeterSecurityExpertInIndiaRouteImport.update({
            id: '/perimeter-security-expert-in-india',path: '/perimeter-security-expert-in-india',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const MediaRoute = MediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => rootRouteImport
          })
const LearningCenterRoute = LearningCenterRouteImport.update({
            id: '/learning-center',path: '/learning-center',getParentRoute: () => rootRouteImport
          })
const InsightsRoute = InsightsRouteImport.update({
            id: '/insights',path: '/insights',getParentRoute: () => rootRouteImport
          })
const IndustriesRoute = IndustriesRouteImport.update({
            id: '/industries',path: '/industries',getParentRoute: () => rootRouteImport
          })
const ForArchitectsRoute = ForArchitectsRouteImport.update({
            id: '/for-architects',path: '/for-architects',getParentRoute: () => rootRouteImport
          })
const ElvConsultantInIndiaRoute = ElvConsultantInIndiaRouteImport.update({
            id: '/elv-consultant-in-india',path: '/elv-consultant-in-india',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const AvConsultantInIndiaRoute = AvConsultantInIndiaRouteImport.update({
            id: '/av-consultant-in-india',path: '/av-consultant-in-india',getParentRoute: () => rootRouteImport
          })
const AskArifRoute = AskArifRouteImport.update({
            id: '/ask-arif',path: '/ask-arif',getParentRoute: () => rootRouteImport
          })
const AiEntityMapRoute = AiEntityMapRouteImport.update({
            id: '/ai-entity-map',path: '/ai-entity-map',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/resources/',path: '/resources/',getParentRoute: () => rootRouteImport
          })
const LocationsIndexRoute = LocationsIndexRouteImport.update({
            id: '/locations/',path: '/locations/',getParentRoute: () => rootRouteImport
          })
const ResourcesSlugRoute = ResourcesSlugRouteImport.update({
            id: '/resources/$slug',path: '/resources/$slug',getParentRoute: () => rootRouteImport
          })
const LocationsSecurityConsultantDelhiNcrRoute = LocationsSecurityConsultantDelhiNcrRouteImport.update({
            id: '/locations/security-consultant-delhi-ncr',path: '/locations/security-consultant-delhi-ncr',getParentRoute: () => rootRouteImport
          })
const LocationsHomeCinemaConsultantDelhiNcrRoute = LocationsHomeCinemaConsultantDelhiNcrRouteImport.update({
            id: '/locations/home-cinema-consultant-delhi-ncr',path: '/locations/home-cinema-consultant-delhi-ncr',getParentRoute: () => rootRouteImport
          })
const LocationsAuditoriumAvConsultantDelhiNcrRoute = LocationsAuditoriumAvConsultantDelhiNcrRouteImport.update({
            id: '/locations/auditorium-av-consultant-delhi-ncr',path: '/locations/auditorium-av-consultant-delhi-ncr',getParentRoute: () => rootRouteImport
          })
const LocationsSlugRoute = LocationsSlugRouteImport.update({
            id: '/locations/$slug',path: '/locations/$slug',getParentRoute: () => rootRouteImport
          })
const AdminSeoMonitorRoute = AdminSeoMonitorRouteImport.update({
            id: '/admin/seo-monitor',path: '/admin/seo-monitor',getParentRoute: () => rootRouteImport
          })
const AdminSecurityMonitorRoute = AdminSecurityMonitorRouteImport.update({
            id: '/admin/security-monitor',path: '/admin/security-monitor',getParentRoute: () => rootRouteImport
          })
const AdminPublishCheckRoute = AdminPublishCheckRouteImport.update({
            id: '/admin/publish-check',path: '/admin/publish-check',getParentRoute: () => rootRouteImport
          })
const AdminLinkedinCardsRoute = AdminLinkedinCardsRouteImport.update({
            id: '/admin/linkedin-cards',path: '/admin/linkedin-cards',getParentRoute: () => rootRouteImport
          })
const AdminGrowthRoute = AdminGrowthRouteImport.update({
            id: '/admin/growth',path: '/admin/growth',getParentRoute: () => rootRouteImport
          })
const AdminFunnelRoute = AdminFunnelRouteImport.update({
            id: '/admin/funnel',path: '/admin/funnel',getParentRoute: () => rootRouteImport
          })
const AdminCtaClicksRoute = AdminCtaClicksRouteImport.update({
            id: '/admin/cta-clicks',path: '/admin/cta-clicks',getParentRoute: () => rootRouteImport
          })
const AdminAbWhatsappRoute = AdminAbWhatsappRouteImport.update({
            id: '/admin/ab-whatsapp',path: '/admin/ab-whatsapp',getParentRoute: () => rootRouteImport
          })
const SolutionsIndexRoute = SolutionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SolutionsRoute
          })
const SolutionsSlugRoute = SolutionsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => SolutionsRoute
          })
const InsightsIndexRoute = InsightsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => InsightsRoute
          })
const InsightsPartnersRoute = InsightsPartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => InsightsRoute
          })
const InsightsMediaRoute = InsightsMediaRouteImport.update({
            id: '/media',path: '/media',getParentRoute: () => InsightsRoute
          })
const InsightsLearningCentreRoute = InsightsLearningCentreRouteImport.update({
            id: '/learning-centre',path: '/learning-centre',getParentRoute: () => InsightsRoute
          })
const InsightsArticlesGuidesRoute = InsightsArticlesGuidesRouteImport.update({
            id: '/articles-guides',path: '/articles-guides',getParentRoute: () => InsightsRoute
          })
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndustriesRoute
          })
const IndustriesSlugRoute = IndustriesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => IndustriesRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const AskArifIndexRoute = AskArifIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AskArifRoute
          })
const AskArifSlugRoute = AskArifSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AskArifRoute
          })
const AskArifCategoryCategoryRoute = AskArifCategoryCategoryRouteImport.update({
            id: '/category/$category',path: '/category/$category',getParentRoute: () => AskArifRoute
          })





const AskArifRouteChildren = {
  AskArifSlugRoute: AskArifSlugRoute,AskArifIndexRoute: AskArifIndexRoute,AskArifCategoryCategoryRoute: AskArifCategoryCategoryRoute
}

const AskArifRouteWithChildren = AskArifRoute._addFileChildren(AskArifRouteChildren)




const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const IndustriesRouteChildren = {
  IndustriesSlugRoute: IndustriesSlugRoute,IndustriesIndexRoute: IndustriesIndexRoute
}

const IndustriesRouteWithChildren = IndustriesRoute._addFileChildren(IndustriesRouteChildren)




const InsightsRouteChildren = {
  InsightsArticlesGuidesRoute: InsightsArticlesGuidesRoute,InsightsLearningCentreRoute: InsightsLearningCentreRoute,InsightsMediaRoute: InsightsMediaRoute,InsightsPartnersRoute: InsightsPartnersRoute,InsightsIndexRoute: InsightsIndexRoute
}

const InsightsRouteWithChildren = InsightsRoute._addFileChildren(InsightsRouteChildren)




const SolutionsRouteChildren = {
  SolutionsSlugRoute: SolutionsSlugRoute,SolutionsIndexRoute: SolutionsIndexRoute
}

const SolutionsRouteWithChildren = SolutionsRoute._addFileChildren(SolutionsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AiEntityMapRoute: AiEntityMapRoute,AskArifRoute: AskArifRouteWithChildren,AvConsultantInIndiaRoute: AvConsultantInIndiaRoute,BlogRoute: BlogRouteWithChildren,ContactRoute: ContactRoute,ElvConsultantInIndiaRoute: ElvConsultantInIndiaRoute,ForArchitectsRoute: ForArchitectsRoute,IndustriesRoute: IndustriesRouteWithChildren,InsightsRoute: InsightsRouteWithChildren,LearningCenterRoute: LearningCenterRoute,MediaRoute: MediaRoute,PartnersRoute: PartnersRoute,PerimeterSecurityExpertInIndiaRoute: PerimeterSecurityExpertInIndiaRoute,ProjectsRoute: ProjectsRoute,SecurityConsultantInIndiaRoute: SecurityConsultantInIndiaRoute,SecuritySolutionsRoute: SecuritySolutionsRoute,SolutionsRoute: SolutionsRouteWithChildren,AdminAbWhatsappRoute: AdminAbWhatsappRoute,AdminCtaClicksRoute: AdminCtaClicksRoute,AdminFunnelRoute: AdminFunnelRoute,AdminGrowthRoute: AdminGrowthRoute,AdminLinkedinCardsRoute: AdminLinkedinCardsRoute,AdminPublishCheckRoute: AdminPublishCheckRoute,AdminSecurityMonitorRoute: AdminSecurityMonitorRoute,AdminSeoMonitorRoute: AdminSeoMonitorRoute,LocationsSlugRoute: LocationsSlugRoute,LocationsAuditoriumAvConsultantDelhiNcrRoute: LocationsAuditoriumAvConsultantDelhiNcrRoute,LocationsHomeCinemaConsultantDelhiNcrRoute: LocationsHomeCinemaConsultantDelhiNcrRoute,LocationsSecurityConsultantDelhiNcrRoute: LocationsSecurityConsultantDelhiNcrRoute,ResourcesSlugRoute: ResourcesSlugRoute,LocationsIndexRoute: LocationsIndexRoute,ResourcesIndexRoute: ResourcesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)